export enum ChacraTipoRendimiento {
  ASEGURADORA = 'RendimientoAseguradora',
  AGLUTINADOR = 'RendimientoAglutinador',
}

export enum ChacraRiesgoGeo {
  NO = '',
  BAJO = 'Bajo',
  MEDIO = 'Medio',
  ALTO = 'Alto',
}
